import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GdprModule } from './gdpr/gdpr.module';
import { GiftCardModule } from './gift-card/gift-card.module';
import { PrivacyNoticeModule } from './privacy-notice/privacy-notice.module';
import {ApacEnPrivacyNoticeModule} from './apac-en-privacy-notice/apac-en-privacy-notice.module';
import { GiftCardErrorModule } from './gift-card-error/gift-card-error.module';
import { GdprSuccessModule } from './gdpr-success/gdpr-success.module';
import { APP_BASE_HREF } from '@angular/common';
import { SaPrivacyNoticeModule } from './sa-privacy-notice/sa-privacy-notice.module';
import { JpEnPrivacyNoticeModule } from './jp-en-privacy-notice/jp-en-privacy-notice.module';
import { JpPrivacyNoticeModule } from './jp-privacy-notice/jp-privacy-notice.module';
import { ChPrivacyNoticeModule } from './ch-privacy-notice/ch-privacy-notice.module';
import { BRPrivacyNoticeModule } from './br-privacy-notice/br-privacy-notice.module';

@NgModule({
  declarations: [
  ],
  imports: [
    GdprModule,
    GiftCardModule,
    GiftCardErrorModule,
    PrivacyNoticeModule,
    ApacEnPrivacyNoticeModule,
    JpEnPrivacyNoticeModule,
    JpPrivacyNoticeModule,
    GdprSuccessModule,
    SaPrivacyNoticeModule,
    ChPrivacyNoticeModule,
    BRPrivacyNoticeModule,
    RouterModule.forRoot([
      { path: '', redirectTo: '', pathMatch: 'full' },
      { path: '**', redirectTo: '', pathMatch: 'full' }
    ])
  ],
  exports: [RouterModule],
  providers: [{provide: APP_BASE_HREF, useValue: ''}]
})
export class AppRoutingModule { }
